import {useSelector, TypedUseSelectorHook} from 'react-redux'
import AppState from '../store/types/app-state'

const useTypedSelector: TypedUseSelectorHook<AppState> = useSelector

export default useTypedSelector
